import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';

export interface Props {
    cours: ReqType.Course[]; // Array<string>
}

/**
 * Ce composant permet l'affichage de la liste des cours pour un utilisateur
 */
export class CoursProfile extends React.Component {
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    DisplayCours = () => {
        return (
            <div className="card card-default">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong>Mes Cours</strong>
                    </h4>
                </div>

                <div className="card-body">
                    <TableChorinitia
                        header={
                            <thead>
                                <tr>
                                    <th scope="col">Cours</th>
                                    <th scope="col">Jour</th>
                                    <th scope="col">Horaire</th>
                                    <th scope="col">Lieu</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {// affichage des cours
                                this.props.cours.map(
                                    (element: ReqType.Course) => {
                                        return (
                                            <tr key={element.id}>
                                                <td>{element.details}</td>
                                                <td>{element.jour}</td>
                                                <td>{element.horaire}</td>
                                                <td>{element.adresse!}</td>
                                            </tr>
                                        );
                                    })
                            }
                        </tbody>
                    </TableChorinitia>
                </div>
            </div>
        );
    }

    render() {
        return (
            <this.DisplayCours />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/CoursProfile.tsx